import FloorplanPreview from "lib/e3plan-preview/e3plan-preview";
import FloorplanManager from "service/e3.plan.manager.js";
import { isMetrical } from 'service/geo.service';
const Promise = require('promise');

export default class MakeFloorplanScreenshots {
    _content = document.createElement('div');
    _placeFroIframe = document.body;
    _container = {};
    _containerLink = {};

    constructor(editable) {
        this._editable = editable;
        this.metrical = true;
    }

    loadScreen(e3plan) {
        this.e3plan = e3plan;

        return new Promise((res, rej) => {
            isMetrical()
                .then((metrical) => {
                    this.metrical = metrical;
                    this.init();
                    this.load();
                    this._floorplanView.on('screenshots', (data) => {
                        this.destroy();
                        const offsets = [];
                        data.screenshots = data.screenshots.filter((screenShoot) => screenShoot.src !== 'data:,' && screenShoot.src.length > 10);
                        data.screenshots.forEach((screenshot) => offsets[screenshot.id] = screenshot.offsets);
                        let markers = this.getMarkers(this.e3plan, offsets);

                        res({
                            textures: data.textures,
                            screenshots: data.screenshots,
                            markers
                        });
                    });
                })

        })
    }

    init() {
        let block = document.createElement('floorplans');
        this._content.appendChild(block);
    }

    getMarkers(e3plan_json, offsets) {
        let markers = [];
        let width = e3plan_json.preview.width;
        let height = e3plan_json.preview.height;
        let layers = e3plan_json.preview.layers;

        for(let i in layers) {
            let layer = layers[i];
            const offset = offsets[i];
            for(let y in layer.areas) {
                let area = layer.areas[y];
                if(area.vertices.length){
                    markers.push({
                        // "y" :  100 - area.properties.scene.camera.y / height * 100,
                        "y" : ( (height - area.properties.scene.camera.y) / height * 100 - offset.offsetTop * 100 )  * offset.height,
                        "imageID" : area.properties.scene.id,
                        "x" :  (area.properties.scene.camera.x / width * 100 - offset.offsetLeft * 100)  * offset.width,
                        // "x" :  area.properties.scene.camera.x / width * 100,
                        "floorplanID" : layer.id
                    })
                }
            }
        }

        return markers
    }

    load() {
        let ration = this.e3plan.preview.width / this.e3plan.preview.height;
        let iframeContainer = this._content.querySelector('floorplans');
        iframeContainer.style.width = 800;
        iframeContainer.style.height = 800 / ration;
        iframeContainer.style.opacity = '0';
        iframeContainer.width = 800;
        iframeContainer.height = 800 / ration;
        iframeContainer.opacity = '0';
        this._floorplanView = new FloorplanPreview(iframeContainer, this._editable, {type: '2d', metrical: this.metrical, iframeID: 'e3-planner-preview--generation'});
        this._floorplanView.on('ready',() => {
            this._floorplanView.off('ready');
            this._generateFloorPlan(this.e3plan, '2d-screenshot');
        });

        this._container = iframeContainer;
        // this._containerLink = this._placeFroIframe.appendChild(this._container)
        this._containerLink =  this._placeFroIframe.insertBefore(this._container, this._placeFroIframe.firstChild);
    }

    _generateFloorPlan(plan, type = '2d') {
        this._floorplanView.loadScreenshot(plan, type);
    }

    destroy() {
        this._floorplanView.destroy();
        this._content = document.createElement('div');
        this._placeFroIframe.removeChild(this._containerLink);
        this._container = {};
        this._containerLink ={}
    }


}
